import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://github.com/CarolinaBrazalesSempere"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i class="uil uil-github-alt"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/carolinabrazales-software-developer/"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i class="uil uil-linkedin"></i>
      </a>
      <a
        href="mailto:carolbrazalessempere@gmail.com"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i class="uil uil-envelope-alt"></i>
      </a>
    </div>
  );
};

export default Social;
